export default __webpack_public_path__ + "media/zurb/img/case-study-iqtell/iqtell-sketches-c78fe0450a1aaae126b948e22181ce52.png";